import React from 'react';
import { Head,Thorax,Abdomen,Pelvis,Limb } from './BasicPages';
import { useParams } from "react-router-dom";


export default function Basic(): JSX.Element {

    const { sitekind } = useParams();
    let lecture: JSX.Element;
    switch (sitekind) {
        case 'head':
            lecture = <Head />;
            break;
        case 'thorax':
            lecture = <Thorax />;
            break;
        case 'abdomen':
            lecture = <Abdomen />;
            break;
        case 'pelvis':
            lecture = <Pelvis />;
            break;
        case 'limb':
            lecture = <Limb />;
            break;
        default:
            lecture =
                <div>
                    <h1>申し訳ありません。こちらのページは存在しないか、只今準備中です。</h1>
                </div>
    }

    React.useEffect(()=>{
        window.scrollTo(0, 0)
    })
    return (
        <div className="container">
            {lecture}
        </div>
    );
}
